export enum StageDialogTabTypes {
  GATES = 'gates',
  AUTOMATIONS = 'sweep_automations',
  SETTINGS = 'settings',
  ASSIGNMENTS = 'assignments',
  ALERTS = 'Alerts',
}
